import ToggleableSection from 'components/ToggleableSection'
import { withContext } from '../Context'
import NeighborhoodTypeSelector from './NeighborhoodTypeSelector'
import StateSelector from './StateSelector'

type LocationSelectorProps = {
  showNeighborhoodType: boolean
}

export const LocationSelector = ({ showNeighborhoodType = true }: LocationSelectorProps) => {
  return (
    <ToggleableSection title="Location">
      <StateSelector />
      {showNeighborhoodType && <NeighborhoodTypeSelector />}
    </ToggleableSection>
  )
}

export default withContext(LocationSelector)
